var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.26,
    x: 0.318512,
    y: 0.318512,
    width: 26.4099,
    height: 26.4099,
    fill: "#EB966A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0255 5.66336L8.0214 5.66336C6.72134 5.66336 5.66338 6.72133 5.66338 8.02138L5.66338 10.2466C5.66338 11.0742 5.96363 11.8264 6.44938 12.405L6.44938 19.8115C6.44938 20.02 6.53219 20.2199 6.6796 20.3673C6.82701 20.5147 7.02693 20.5975 7.23539 20.5975H13.5235C13.7319 20.5975 13.9318 20.5147 14.0792 20.3673C14.2267 20.2199 14.3095 20.02 14.3095 19.8115V15.8815H17.4535V19.8115C17.4535 20.02 17.5363 20.2199 17.6837 20.3673C17.8311 20.5147 18.031 20.5975 18.2395 20.5975H19.8115C20.02 20.5975 20.2199 20.5147 20.3673 20.3673C20.5147 20.2199 20.5975 20.02 20.5975 19.8115V12.4042C21.0833 11.8264 21.3835 11.0742 21.3835 10.2458V8.02138C21.3835 6.72133 20.3256 5.66336 19.0255 5.66336ZM19.8115 8.02138V10.2466C19.8115 11.1426 19.1442 11.9066 18.3252 11.9499L18.2395 11.9514C17.3725 11.9514 16.6675 11.2464 16.6675 10.3794V7.23538H19.0255C19.4594 7.23538 19.8115 7.58829 19.8115 8.02138ZM11.9514 10.3794V7.23538H15.0955V10.3794C15.0955 11.2464 14.3904 11.9514 13.5235 11.9514C12.6565 11.9514 11.9514 11.2464 11.9514 10.3794ZM7.23539 8.02138C7.23539 7.58829 7.58752 7.23538 8.0214 7.23538H10.3794V10.3794C10.3794 11.2464 9.67437 11.9514 8.80741 11.9514L8.72173 11.9491C7.90271 11.9066 7.23539 11.1426 7.23539 10.2466V8.02138ZM11.9514 16.6675H8.80741L8.80741 14.3094H11.9514V16.6675Z",
    fill: "url(#paint0_linear_9427_3254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9427_3254",
    x1: 13.5235,
    y1: 5.66336,
    x2: 13.5235,
    y2: 20.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA6969"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d33bedcd917194d9fa875935a8be313.svg";
export { ForwardRef as ReactComponent };